/**
 * ResponsavelUsuario
 * @author Simpli CLI generator
 */
import {$, Helper, Request, Resource} from 'simpli-web-sdk'
import {ResponseSerialize} from 'simpli-web-sdk'
import {Responsavel} from '@/model/resource/Responsavel'
import {ResponsavelUsuarioCollection} from '@/model/collection/ResponsavelUsuarioCollection'
import {TipoResponsavelUsuario} from '@/model/resource/TipoResponsavelUsuario'
import {TipoResponsavelUsuarioCollection} from '@/model/collection/TipoResponsavelUsuarioCollection'
import {sha256} from 'js-sha256'

export class ResponsavelUsuario extends Resource {
  idResponsavelUsuarioPk: number = 0

  @ResponseSerialize(Responsavel)
  responsavel: Responsavel | null = null

  @ResponseSerialize(TipoResponsavelUsuario)
  tipoResponsavelUsuario: TipoResponsavelUsuario | null = null

  nome: string | null = null
  email: string | null = null
  senha: string | null = null
  permitirCadastrarUsuario: boolean | null = null
  ehSenhaTemporaria: boolean | null = null
  ativo: boolean | null = null
  ehCriacao: boolean = false

  get $id() {
    return this.idResponsavelUsuarioPk
  }
  set $id(val) {
    this.idResponsavelUsuarioPk = val
  }

  get idResponsavelFk() {
    if (!this.responsavel) return 0
    return this.responsavel.$id
  }
  set idResponsavelFk(val) {
    if (!this.responsavel) this.responsavel = new Responsavel()
    this.responsavel.$id = val
  }

  get idTipoResponsavelUsuarioFk() {
    if (!this.tipoResponsavelUsuario) return 0
    return this.tipoResponsavelUsuario.$id
  }
  set idTipoResponsavelUsuarioFk(val) {
    if (!this.tipoResponsavelUsuario)
      this.tipoResponsavelUsuario = new TipoResponsavelUsuario()
    this.tipoResponsavelUsuario.$id = val
  }

  set tipoResponsavelUsuarioAsResource(input: Resource | null) {
    this.idTipoResponsavelUsuarioFk = Number(input?.$id) || 0
  }

  get tipoResponsavelUsuarioAsResource() {
    return new TipoResponsavelUsuarioCollection()
      .options()
      .getResource(this.idTipoResponsavelUsuarioFk ?? 0)
  }

  /**
   * Gets a instance of a given ID of ResponsavelUsuario
   */
  async getResponsavelUsuario(id: number) {
    return await Request.get(`/admin/responsavel-usuario/${id}`)
      .name('getResponsavelUsuario')
      .as(this)
      .getData()
  }

  /**
   * Deletes a instance of a given ID of ResponsavelUsuario
   */
  async removeResponsavelUsuario() {
    return await Request.delete(`/admin/responsavel-usuario/${this.$id}`)
      .name('removeResponsavelUsuario')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of ResponsavelUsuario
   */
  static async listResponsavelUsuario(params: any) {
    return await Request.get(`/admin/responsavel-usuario`, {params})
      .name('listResponsavelUsuario')
      .as(ResponsavelUsuarioCollection)
      .getData()
  }

  /**
   * Persists a new instance of ResponsavelUsuario. Use ID = 0 to create a new one,
   * or ID > 0 to update a current one
   */
  async persistResponsavelUsuario() {
    const request = this.$clone()
    request.senha = this.senha ? sha256(this.senha) : null
    return await Request.post(`/admin/responsavel-usuario`, request)
      .name('persistResponsavelUsuario')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of ResponsavelUsuario to use it in a CSV file
   */
  static async listCsvResponsavelUsuario(params: any) {
    return await Request.get(`/admin/responsavel-usuario/csv`, {params})
      .name('listCsvResponsavelUsuario')
      .as(ResponsavelUsuarioCollection)
      .getData()
  }
}
